/**
 * ClientRoute — V5-T9
 * Guard de route pour le portail client.
 */
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useClientAuth } from "../../contexts/ClientAuthContext";

export default function ClientRoute({ children }) {
  const { isAuthenticated } = useClientAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/client/login" state={{ from: location }} replace />;
  }

  return children;
}
